import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_ITEMS_BY_TRANSFER_ID = "[TRANSFER ITEMS] GET ITEMS BY TRANSFER ID"
export const SAVE_TRANSFER_ITEM = "[TRANSFER ITEMS] SAVE TRANSFER ITEM"
export const ADD_QUANTITY_TO_TRANSFER_ITEM = "[TRANSFER ITEMS] ADD QUANTITY TO TRANSFER ITEM"
export const SUBTRACT_QUANTITY_TO_TRANSFER_ITEM = "[TRANSFER ITEMS] SUBTRACT QUANTITY TO TRANSFER ITEM"
export const REMOVE_TRANSFER_ITEM = "[TRANSFER ITEMS] REMOVE TRANSFER ITEM"

export function getItemsByTransferId(transferId) {
  const request = api.get(`/transfer-items/by-transfer/${transferId}`)
  return (dispatch) => {
    dispatch({ type: GET_ITEMS_BY_TRANSFER_ID, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_ITEMS_BY_TRANSFER_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo obtener los items del traslado")
      console.log(GET_ITEMS_BY_TRANSFER_ID, error)
    }).finally(() => {
      dispatch({ type: GET_ITEMS_BY_TRANSFER_ID, payload: { loading: false } })
    })
  }
}

export function saveTransferItem(data) {
  const request = api.post(`/transfer-item/save`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_TRANSFER_ITEM, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_TRANSFER_ITEM, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo guardar el items en el traslado")
      console.log(SAVE_TRANSFER_ITEM, error)
    }).finally(() => {
      dispatch({ type: SAVE_TRANSFER_ITEM, payload: { saving: false, saved: false } })
    })
  }
}

export function addQuantityToTransferItem(transferItemId, quantity) {
  const request = api.put(`/transfer-item/${transferItemId}/add-quantity/${quantity}`)
  return (dispatch) => {
    dispatch({ type: ADD_QUANTITY_TO_TRANSFER_ITEM, payload: { adding_id: transferItemId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: ADD_QUANTITY_TO_TRANSFER_ITEM, payload: { added_id: transferItemId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo agregar la cantidad al item del traslado")
      console.log(ADD_QUANTITY_TO_TRANSFER_ITEM, error)
    }).finally(() => {
      dispatch({ type: ADD_QUANTITY_TO_TRANSFER_ITEM, payload: { adding_id: transferItemId } })
    })
  }
}

export function subtractQuantityToTransferItem(transferItemId, quantity) {
  const request = api.put(`/transfer-item/${transferItemId}/subtract-quantity/${quantity}`)
  return (dispatch) => {
    dispatch({ type: SUBTRACT_QUANTITY_TO_TRANSFER_ITEM, payload: { subtracting_id: transferItemId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SUBTRACT_QUANTITY_TO_TRANSFER_ITEM, payload: { subtracted_id: transferItemId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo restar la cantidad al item del traslado")
      console.log(SUBTRACT_QUANTITY_TO_TRANSFER_ITEM, error)
    }).finally(() => {
      dispatch({ type: SUBTRACT_QUANTITY_TO_TRANSFER_ITEM, payload: { subtracting_id: transferItemId } })
    })
  }
}

export function removeTransferItem(transferItemId) {
  const request = api.delete(`/transfer-item/remove/${transferItemId}`)
  return (dispatch) => {
    dispatch({ type: REMOVE_TRANSFER_ITEM, payload: { removing_id: transferItemId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: REMOVE_TRANSFER_ITEM, payload: { removed_id: transferItemId } })
      toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo remover el item del traslado")
      console.log(REMOVE_TRANSFER_ITEM, error)
    }).finally(() => {
      dispatch({ type: REMOVE_TRANSFER_ITEM, payload: { removing_id: transferItemId } })
    })
  }
}
